// src/api/categoryApi.js
import config from '../config';

export const getAllCategories = async () => {
  const response = await fetch(`${config.apiUrl}/categories`);

  if (!response.ok) throw new Error('Failed to fetch categories');
  return response.json();
};

export const fetchCategories = async (filters = {}) => {
  const query = new URLSearchParams(filters).toString();
  const response = await fetch(`${config.apiUrl}/categories/search/param=?&${query}`);

  if (!response.ok) throw new Error('Failed to fetch categories');
  return response.json();
};

export const createCategory = async (categoryData) => {
  const response = await fetch(`${config.apiUrl}/categories/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(categoryData),
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};

export const deleteCategory = async (categoryId) => {
  const response = await fetch(`${config.apiUrl}/categories/${categoryId}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};

export const editCategory = async (categoryData) => {
  const response = await fetch(`${config.apiUrl}/categories/${categoryData.category_id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(categoryData),
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};

export const uploadCategoryPhoto = async (categoryId, imageData) => {
  const response = await fetch(`${config.apiUrl}/categories/${categoryId}/image`, {
    method: 'PUT',
    body: imageData, // Assuming imageData is a FormData object
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};

